import React from "react";

// import barGraph from "./graphics/bar-graph.svg";
import genericClassroom from "./graphics/classroom.svg";
import calculator from "./graphics/tcmpc/math.svg";
import prek from "./graphics/tcmpc/pre-k.svg";
import readingSpanish from "./graphics/tcmpc/reading-spanish.svg";
import reading from "./graphics/tcmpc/reading.svg";
import science from "./graphics/tcmpc/science.svg";
import geography from "./graphics/tcmpc/social-studies.svg";

const defaultTitles: Record<string, string> = {
  MATH: "Math",
  SLA: "Spanish Language Arts",
  ELA: "English Language Arts",
  SCI: "Science",
  SS: "Social Studies",
};

const SubjectIcon = (props: {
  value?: string;
  height?: string;
  title?: string;
}) => {
  let icon: string | undefined;

  switch (props.value) {
    case "MATH":
      icon = calculator;
      break;
    case "SLA":
      icon = readingSpanish;
      break;
    case "ELA":
      icon = reading;
      break;
    case "SCI":
      icon = science;
      break;
    case "SS":
      icon = geography;
      break;
    case "PK":
      icon = prek;
      break;
    default:
      icon = genericClassroom;
      break;
  }

  const title =
    props.title ??
    (props.value ? defaultTitles[props.value] : undefined) ??
    "TCMPC Logo";

  return (
    <img
      height={props.height ?? "42"}
      width={props.height ?? "42"}
      src={icon}
      alt={props.title ?? "TCMPC Logo"}
      title={title}
    />
  );
};

export default SubjectIcon;
